import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';

import { AuthService } from './auth.service';
import { StoreHelper } from '../shared/helpers/store.helper';

@Injectable()
export class AuthGuardNoLoad implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {


      if (this.authService.isAuthenticated() && StoreHelper.isActive()) {
        return true
      }

      this.router.navigate(['/signin']);

      return false
  }
}
